// extracted by mini-css-extract-plugin
export var column = "NavColumn-module--column--b5d9b";
export var link = "NavColumn-module--link--63ac9";
export var title = "NavColumn-module--title--61d42";